import React from "react";
import { Reveal, SectionLabel } from "./motion";
import { useLang } from "@/LanguageContext";
import { IMAGES } from "@/content";

export default function Mission() {
  const { t } = useLang();
  return (
    <section id="mission" data-testid="mission-section" className="relative py-24 lg:py-36 bg-navy overflow-hidden">
      <div className="absolute -left-40 top-20 w-[36rem] h-[36rem] glow-teal rounded-full blur-3xl opacity-60" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <Reveal><SectionLabel>{t.mission.eyebrow}</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-white mt-6 tracking-[-0.01em]">
              {t.mission.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="font-serif italic text-xl sm:text-2xl text-gold leading-snug mt-8 max-w-2xl">{t.mission.lead}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-white/60 text-base sm:text-lg leading-relaxed mt-6 max-w-2xl">{t.mission.body}</p>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1} y={60}>
            <div className="img-zoom relative aspect-[4/5] rounded-sm border border-white/10">
              <img src={IMAGES.brussels} alt="Brussels" className="w-full h-full object-cover rounded-sm" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/70 to-transparent rounded-sm" />
              <div className="absolute bottom-5 left-5 text-xs uppercase tracking-[0.3em] text-white/80">Brussels · Belgium</div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
